// extracted by mini-css-extract-plugin
export default {"collapse":"styles__collapse___wJp_0","header":"styles__header___lLoEX","body":"styles__body___fUc9a","isOpen":"styles__isOpen___LDVSu"};